import { useState } from "react";
import PropTypes from "prop-types";
import csrfAxios from "@shared/csrfAxios";

import Button from "@shared/v2/Button";
import Tag from "@shared/v2/Tag";
import TextComboInput from "@shared/v2/TextComboInput";

const TransactlyUser = ({ onChangeTeam, user }) => {
  const [accountId, setAccountId] = useState("");
  const [error, setError] = useState("");

  const { teams } = user;

  const onClickButton = async () => {
    const params = { transactly_coordinator: { account_id: accountId, okta_id: user.id } };

    setError("");

    csrfAxios
      .post("/support/transactly_coordinators", params)
      .then((response) => {
        onChangeTeam({ userId: user.id, newAllUsers: response.data });

        setAccountId("");
      })
      .catch(() => {
        setError("Unable to save this Team.");
      });
  };

  const onRemoveTag = async (val) => {
    const params = { transactly_coordinator: { id: val } };

    const endpoint = `/support/transactly_coordinators/${val}`;

    csrfAxios.delete(endpoint, params).then((response) => {
      onChangeTeam({ userId: user.id, newAllUsers: response.data });
    });
  };

  return (
    <div>
      <h2>{user.first_name || "User"}&apos;s Teams</h2>

      <div className="tw-flex tw-flex-col tw-gap-y-4">
        <div className="tw-flex tw-gap-[16px] tw-items-end">
          <TextComboInput
            containerClassName="tw-flex-1"
            error={error}
            label="Account ID"
            onChange={(e) => {
              setAccountId(e.target.value);
            }}
            value={accountId}
          />

          <Button onClick={onClickButton} size="medium">
            Add Team
          </Button>
        </div>

        <div className="tw-flex tw-gap-[8px]">
          {teams.map((t) => {
            return (
              <Tag
                key={`team-${t.id}`}
                onRemove={() => {
                  onRemoveTag(t.id);
                }}
              >
                {t.team_name}
              </Tag>
            );
          })}
        </div>
      </div>
    </div>
  );
};

TransactlyUser.propTypes = {
  onChangeTeam: PropTypes.func.isRequired,
  user: PropTypes.shape({
    first_name: PropTypes.string,
    id: PropTypes.string,
    teams: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  }).isRequired,
};

export default TransactlyUser;
